import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { api } from '@/store/api'

import s from './LangSelect.module.scss'
import type { LangSelectProps, Langs } from './LangSelect.props'

const langs: Langs = {
  ru: {
    key: 'RU',
    title: 'Русский',
  },
  uk: {
    key: 'UA',
    title: 'Украинский',
  },
}

export function LangSelect({ ...props }: LangSelectProps) {
  const { i18n } = useTranslation()
  const dispatch = useDispatch()

  const onSelectLang = (lang: string) => {
    i18n.changeLanguage(lang)
    dispatch(api.util.resetApiState())
  }

  return (
    <div className={s.wrapper}>
      <div className={s.activeLang}>{langs[i18n.language]?.key}</div>

      <div className={s.listWrapper}>
        <div className={s.list}>
          {[...i18n.languages].sort().map((i) => (
            <div
              key={i}
              onClick={() => onSelectLang(i)}
              className={classNames(s.item, { [s.active]: i18n.language === i })}
            >
              {langs[i]?.title}, {langs[i]?.key}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
